import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/store-helper";
import { DevFeaturesState } from "@store/dev-features/dev-features-slice";

/**
 * Selector to get the entire dev features state.
 */
export const devFeaturesStateSelector = createSelector(
(state: RootState) => state.devFeatures,
(devFeatures): DevFeaturesState => {
   return {
      isTranslationOverrideAllowed: devFeatures.isTranslationOverrideAllowed,
      isDarkModeEnabled: devFeatures.isDarkModeEnabled,
   };
}
);